import React from 'react';
import IClinicalContact from '../../../../interfaces/IClinicalContact';
import { ButtonGroup } from 'react-bootstrap';
import ModalButton from '../../../ModalButton';
import ClinicalContactEntry from '../Components/ClinicalContactEntry';

interface ClinicalContactActionsProps {
    handleUpdateClinicalContact: (index: number) => void;
    index: number;
    setEditableClinicalContact: (
        value: ((prevState: IClinicalContact) => IClinicalContact) | IClinicalContact
    ) => void;
    generateNewClientTemplate: (template?: IClinicalContact) => IClinicalContact;
    contact: IClinicalContact;
    isValid: (contact: IClinicalContact) => boolean;
    editableClinicalContact: IClinicalContact;
    isCA: boolean;
    handleEditableClinicalContactUpdate: (name: string, value: any) => void;
    handleDeleteClient: (index: number) => void;
}

const ClinicalContactActions: React.FC<ClinicalContactActionsProps> = ({
    handleUpdateClinicalContact,
    index,
    setEditableClinicalContact,
    generateNewClientTemplate,
    contact,
    isValid,
    editableClinicalContact,
    isCA,
    handleEditableClinicalContactUpdate,
    handleDeleteClient,
}) => {
    return (
        <ButtonGroup>
            <ModalButton
                buttonText={''}
                modalProps={{ size: 'lg' }}
                confirmBtnText={'Update clinical contact'}
                onConfirmModalBtn={() => handleUpdateClinicalContact(index)}
                onCancelModalBtn={() => setEditableClinicalContact(generateNewClientTemplate())}
                beforeShow={() => {
                    setEditableClinicalContact(contact);
                }}
                modalTitle={'Edit clinical contact'}
                buttonProps={{
                    as: 'i',
                    className:
                        'btn-sm btn-secondary border-0 text-secondary bi bi-pencil bg-transparent fs-5',
                    title: 'Edit client ' + contact.initials,
                }}
                cancelButtonProps={{
                    variant: 'outline-secondary',
                    className: 'text-primary fs-6',
                }}
                confirmButtonProps={{
                    className: 'text-primary fs-6',
                    disabled: !isValid(editableClinicalContact),
                }}
            >
                <ClinicalContactEntry
                    index={index}
                    contact={editableClinicalContact}
                    showAge={isCA}
                    handleInputChange={(name, value) =>
                        handleEditableClinicalContactUpdate(name, value)
                    }
                />
            </ModalButton>
            <ModalButton
                buttonText={''}
                confirmBtnText="Confirm: delete"
                onConfirmModalBtn={() => handleDeleteClient(index)}
                buttonProps={{
                    as: 'i',
                    className: 'btn-sm text-danger border-0 bi bi-trash bg-transparent fs-5',
                    title: 'Delete client ' + contact.initials,
                }}
                modalTitle="Are you sure you want to delete this record?"
                confirmButtonProps={{
                    variant: 'outline-danger',
                }}
                cancelButtonProps={{
                    variant: 'outline-secondary',
                }}
                cancelBtnText="Cancel: keep record"
            >
                This can't be undone.
            </ModalButton>
        </ButtonGroup>
    );
};

export default ClinicalContactActions;
